import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

import { useForm } from "react-hook-form";
import { API_URL, useAxios } from "../../../../../utils/const";
import { useToast } from "../../../../../Context/ToastContext";
import { Message } from "primereact/message";
const UpdateModalKKD = ({
  toggleModal,
  id,
  getCourseStudents,
  student,
  course_type,
  course_group_timetable_kkd_id,
  period_id,
}) => {
  const axiosInstance = useAxios();
  const { setToastObj } = useToast();

  const {
    register,
    setValue,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      name: student.student.name,
      description: student.description,
    },
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        if (student.check_in == null) {
          await getCurrentTime();
        } else {
          setValue("check_in", student.check_in);
        }
        await getPenilaianProses();
      } catch (error) {
        setToastObj({
          msg: error,
          type: "danger",
        });
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const getCurrentTime = async () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0"); // Add leading zero if needed
    const minutes = String(now.getMinutes()).padStart(2, "0"); // Add leading zero if needed
    setValue("check_in", `${hours}:${minutes}`);
  };

  const getPenilaianProses = async () => {
    const data = {
      course_group_timetable_kkd_id: course_group_timetable_kkd_id,
      period_id: period_id,
      student_id: student.student.id,
    };
    const response = await axiosInstance.post(
      `${API_URL}/tutorial-penilaian-proses/find/kkd`,
      data
    );
    if (response.data.data != null) {
      setValue(
        "kritis",
        response.data.data.kritis ? response.data.data.kritis.toString() : ""
      );
      setValue(
        "relevansi",
        response.data.data.relevansi
          ? response.data.data.relevansi.toString()
          : ""
      );
      setValue(
        "komunikasi",
        response.data.data.komunikasi
          ? response.data.data.komunikasi.toString()
          : ""
      );
      setValue(
        "disiplin",
        response.data.data.disiplin
          ? response.data.data.disiplin.toString()
          : ""
      );
      setValue(
        "sikap",
        response.data.data.sikap ? response.data.data.sikap.toString() : ""
      );
      setValue(
        "tanggapan",
        response.data.data.tanggapan ? response.data.data.tanggapan : ""
      );
    }
  };

  const closeModal = () => {
    toggleModal(false);
  };

  const handleSave = async (formData) => {
    setLoading(true);
    try {
      const data = {
        kritis: {
          value: formData.kritis,
          description:
            formData.kritis === "0"
              ? "Tidak Hadir/ tidak memberikan tanggapan/analisis/ pertanyaan"
              : formData.kritis === "1"
              ? "Menyampaikan analisis atau pertanyaan menggali pengetahuan, atau memberi tanggapan namun tidak logis atau isi tidak sesuai"
              : formData.kritis === "2"
              ? "Menyampaikan analisis atau pertanyaan menggali pengetahuan, atau memberi tanggapan dengan logis atau isi sesuai, namun harus dipicu tutor"
              : formData.kritis === "3"
              ? "Menyampaikan analisis atau pertanyaan menggali pengetahuan, atau memberi tanggapan dengan logis atau isi sesuai, secara mandiri, sesuai kebutuhan diskusi"
              : "",
        },
        relevansi: {
          value: formData.relevansi,
          description:
            formData.relevansi === "0"
              ? "Tidak menunjukkan keaktifan atau partisipasi dalam diskusi"
              : formData.relevansi === "1"
              ? "Menunjukkan sedikit partisipasi dalam diskusi di sebagian kecil waktu"
              : formData.relevansi === "2"
              ? "Menunjukkan partisipasi aktif dalam diskusi di sebagian besar waktu, atau sesekali harus diingatkan atau diminta"
              : formData.relevansi === "3"
              ? "Menunjukkan partisipasi aktif dalam diskusi secara konsisten"
              : "",
        },
        komunikasi: {
          value: formData.komunikasi,
          description:
            formData.komunikasi === "0"
              ? "Tidak menyampaikan pendapat/pertanyaan/ argumentasi"
              : formData.komunikasi === "1"
              ? "Menyampaikan pendapat/pertanyaan/argumentasi dengan cara penyampaian yang sulit dipahami dan/atau dengan frekuensi jarang"
              : formData.komunikasi === "2"
              ? "Menyampaikan pendapat/argumentasi/ pertanyaan dengan bahasa yang baik dan mudah dipahami namun kurang konsisten"
              : formData.komunikasi === "3"
              ? "Menyampaikan pendapat/argumentasi/ pertanyaan dengan bahasa yang baik dan mudah dipahami secara konsisten"
              : "",
        },
        disiplin: {
          value: formData.disiplin,
          description:
            formData.disiplin === "0"
              ? "Tidak hadir dalam diskusi atau hadir sangat terlambat. Tidak mengumpulkan atau melaksanakan tugas diskusi"
              : formData.disiplin === "1"
              ? "Terlambat hadir diskusi > 15 menit. Terlambat mengumpulkan atau melaksanakan tugas diskusi"
              : formData.disiplin === "2"
              ? "Terlambat hadir diskusi < 15 menit. Mengumpulkan atau melaksanakan tugas diskusi dengan cukup baik dan sesuai target"
              : formData.disiplin === "3"
              ? "Hadir tepat waktu Mengumpulkan atau melaksanakan tugas diskusi dengan baik dan sesuai target"
              : "",
        },
        sikap: {
          value: "0",
          description: "-",
        },
        tanggapan: formData.tanggapan,
        student_id: student.student.id,
        keterangan: formData.description,
        check_in: formData.check_in,
      };

      await axiosInstance.put(
        `${API_URL}/course-attendances/lecturer/nilai-proses/${id}/${course_type}`,
        data
      );

      getCourseStudents();
      setLoading(false);
      setToastObj({ msg: "Data Berhasil diubah", type: "success" });
      closeModal();
    } catch (error) {
      let errorMessage = "Terjadi kesalahan";
      if (error.response.data.msg != undefined) {
        errorMessage = `Terjadi kesalahan, ${error.response.data.msg}`;
      } else {
        errorMessage = error.message;
      }
      setLoading(false);
      setToastObj({
        msg: errorMessage,
        type: "danger",
      });
      closeModal();
    }
  };

  return loading == false ? (
    <Modal show={toggleModal} size="xl" onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>
          <h6>Ubah Kehadiran</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/** STUDENT INFO */}
        <div className="row mb-4">
          {/* NAME */}
          <div className="col-md-4">
            <div className="form-group ">
              <label className="form-label">Nama</label>
              <input
                {...register("name")}
                type="text"
                disabled
                className="form-control"
              />
            </div>
          </div>

          {/* CHECK IN TIME */}
          <div className="form-group mb-3">
            <label className="form-label">Waktu Hadir</label>
            <input
              {...register("check_in", {
                required: "Waktu hadir tidak boleh kosong!",
              })}
              type="time"
              className="form-control"
            />
            {errors.check_in && (
              <div className="">
                <Message
                  className="mt-2 d-flex"
                  severity="error"
                  text={errors.check_in.message}
                />
              </div>
            )}
          </div>

          {/* DESCRIPTION */}
          <div className="col-md-12">
            <div className="form-group ">
              <label className="form-label">Keterangan</label>
              <textarea
                {...register("description")}
                className="form-control"
              ></textarea>
            </div>
          </div>
        </div>

        {/** PENILAIAN */}
        <div className="row mb-4">
          <div className="table-responsive">
            <table className="table table-striped table-bordered">
              <thead>
                <tr className="fw-bold">
                  <th>Kriteria Penilaian</th>
                  <th className="text-center">0</th>
                  <th className="text-center">1</th>
                  <th className="text-center">2</th>
                  <th className="text-center">3</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <strong>Kesiapan Materi :</strong> Komitmen untuk
                    mempersiapkan diri sebaik mungkin untuk KKD, mampu
                    menjelaskan konsep penting keterampilan yang dipelajari
                    <strong>(Krama: tekun, tekun, terampil, sportif)</strong>
                  </td>
                  {["0", "1", "2", "3"].map((value) => (
                    <td key={`kritis_${value}`}>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="kritis"
                          {...register("kritis")}
                          id={`kritis_${value}`}
                          value={value}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`kritis_${value}`}
                        >
                          {value === "0" &&
                            "Tidak Hadir/ tidak memiliki pengetahuan tentang konsep penting dalam keterampilan yang dilatihkan"}
                          {value === "1" &&
                            "Menunjukkan pengetahuan tentang konsep penting dalam keterampilanyang dilatihkan namun masih superfisial/sedikit"}
                          {value === "2" &&
                            "Menunjukkan pengetahuan tentang konsep penting dalam keterampilan yang dilatihkan di sebagian besar topik"}
                          {value === "3" &&
                            "Menunjukkan pengetahuan tentang konsep penting dalam keterampilan yang dilatihkan secara keseluruhan"}
                        </label>
                      </div>
                    </td>
                  ))}
                </tr>

                <tr>
                  <td>
                    <strong>keaktifan :</strong> Inisiatif dan partisipasi aktif
                    dalam proses pelatihan keterampilan
                    <strong>(Krama: tekun, asah, setia)</strong>
                  </td>
                  {["0", "1", "2", "3"].map((value) => (
                    <td key={`relevansi_${value}`}>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="relevansi"
                          {...register("relevansi")}
                          id={`relevansi_${value}`}
                          value={value}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`relevansi_${value}`}
                        >
                          {value === "0" &&
                            "Tidak hadir/tidak melakukan latihan keterampilan"}
                          {value === "1" && "Melakukan latihan karena ditunjuk"}
                          {value === "2" &&
                            "Melakukan latihan secara aktif tetapi masih belum benar"}
                          {value === "3" &&
                            "Melakukan latihan secara aktif dan benar"}
                        </label>
                      </div>
                    </td>
                  ))}
                </tr>

                <tr>
                  <td>
                    <strong>Disiplin :</strong> Kehadiran mahasiswa dalam
                    pelatihan keterampilan dan/atau kemampuan mengumpulkan tugas
                    <strong>(Krama: takwa, tekun, terampil)</strong>
                  </td>
                  {["0", "1", "2", "3"].map((value) => (
                    <td key={`komunikasi_${value}`}>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="komunikasi"
                          {...register("komunikasi")}
                          id={`komunikasi_${value}`}
                          value={value}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`komunikasi_${value}`}
                        >
                          {value === "0" &&
                            "Tidak hadir dan/atau tidak mengumpulkan tugas"}
                          {value === "1" &&
                            "Terlambat hadir >15 Menit dan/atau Terlambat mengumpulkan tugas"}
                          {value === "2" &&
                            "Terlambat hadir < 15 menit dan/atau Mengumpulkan tugas tepat waktu"}
                          {value === "3" &&
                            "Hadir tepat waktu Mengumpulkan tugas tepat waktu"}
                        </label>
                      </div>
                    </td>
                  ))}
                </tr>

                <tr>
                  <td>
                    <strong>Sikap :</strong>
                    Sikap menghargai, sopan , menyimak dan mendengarkan
                    penjelasan instruktur, membantu teman sekelompok, jujur,
                    bertanggung jawab, rendah hati, mampu mencari dan menerima
                    umpan balik.
                    <strong>(Krama: takwa, asih, satria, sportif)</strong>
                  </td>
                  {["0", "1", "2", "3"].map((value) => (
                    <td key={`disiplin_${value}`}>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="disiplin"
                          {...register("disiplin")}
                          id={`disiplin_${value}`}
                          value={value}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`disiplin_${value}`}
                        >
                          {value === "0" && "Tidak Hadir"}
                          {value === "1" &&
                            "Acuh terhadap instruktur atau teman/melakukan kegiatan lain yang tidak terkait pelatihan, kurang peka terhadap umpan balik"}
                          {value === "2" &&
                            "Menyimak dan mendengarkan penjelasan instruktur tetapi TIDAKmemperhatikan dan TIDAK mau membantu teman dalam pelatihan, menerimaumpan balik"}
                          {value === "3" &&
                            "Menyimak dan mendengarkan penjelasan instruktur, memperhatikan danmau membantuteman dalam pelatihan, aktif mencari dan menerima umpan balik"}
                        </label>
                      </div>
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/** TANGGAPAN */}
        <div class="row mb-3">
          <div class="col-md-12 mb-3">
            <div class="form-group">
              <label for="update_tanggapan_tutorial" class="form-label">
                Tanggapan
              </label>
              <textarea
                name="tanggapan"
                {...register("tanggapan")}
                id="update_tanggapan_tutorial"
                rows="2"
                class="form-control"
              ></textarea>
            </div>
          </div>
        </div>

        {/** RUMUS NILAI */}
        <div class="row mb-3">
          <h5>
            <strong class="text-decoration-underline">
              NILAI AKHIR : (TOTAL/15)X100
            </strong>
          </h5>
        </div>

        <button
          className="btn w-100 btn-success"
          onClick={handleSubmit(handleSave)}
        >
          Ubah
        </button>
      </Modal.Body>
    </Modal>
  ) : (
    <Modal show={toggleModal} onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>
          <h6>Ubah Kehadiran</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="col-md-12 text-center align-center">
          <h1>Mohon Tunggu</h1>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UpdateModalKKD;
